import React from "react";
import BotonRegresar from "./shared/BotonRegresar";

export default function Quienes({ onBack }) {
  return (
    <div className="row" style={{ marginBottom: "4rem" }}>
      <div
        className="card col l6 offset-l3"
        style={{ borderRadius: "20px", padding: "0", overflow: "hidden" }}
      >
        {/* Imagen de encabezado */}
        <div
          // style={{
          //   backgroundImage: "url('/assets/images/nosotros.jpg')",
          //   backgroundSize: "cover",
          //   backgroundPosition: "center",
          //   height: "250px",
          //   position: "relative",
          //   display: "flex",
          //   alignItems: "center",
          //   justifyContent: "center",
          // }}
        >
          {/* Degradado inferior */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              height: "80px",
              width: "100%",
              // background:
                // "linear-gradient(to top, white 50%, transparent 100%)",
              zIndex: 1,
            }}
          />
          {/* Texto "NOSOTROS" sobre fondo translúcido */}
          <div
         
          >
            {/* <h2
              style={{
                fontWeight: 700,
                color: "#132c64",
                textAlign: "center",
                fontSize: 48,
                margin: 0,
              }}
            >
              NOSOTROS
            </h2> */}
          </div>
        </div>

        {/* Contenido interno */}
        <div style={{ padding: "2rem" }}>
          {/* ¿Quiénes somos? */}
          <h4
            className="center-align"
            style={{ color: "#a2b0d3", fontWeight: "bold" }}
          >
            ¿QUIÉNES SOMOS?
          </h4>
          <p
            className="center-align"
            style={{ fontSize: "18px", color: "#444" }}
          >
       Somos una asociación civil sin fines de lucro que realiza
                    actividades humanitarias para apoyar a las niñas, niños y
                    adolescentes con cáncer y enfermedades
                    crónico-degenerativas.<br></br> Nuestro objetivo es
            acompañarlos con dignidad, brindando medicina, atención emocional,
            educación y el amor de una comunidad solidaria.
          </p>

          {/* Misión, Visión, Valores */}
          <div className="row center-align" style={{ marginTop: "3rem" }}>
            <div className="col s12 m4">
              <img
                src="/assets/images/mision2.png"
                alt="Misión"
                style={{ width: "60px", marginBottom: "1rem" }}
              />
              <h5 style={{ color: "#a2b0d3", fontWeight: "600" }}>MISIÓN</h5>
              <p>
                 
                Nuestros esfuerzos se orientan a satisfacer los requerimientos
                clínicos y acompañar a la familia mientras que el paciente menor
                de edad se encuentra en tratamiento clínico.
              </p>
            </div>
            <div className="col s12 m4">
              <img
                src="/assets/images/vision.png"
                alt="Visión"
                style={{ width: "60px", marginBottom: "1rem" }}
              />
              <h5 style={{ color: "#a2b0d3", fontWeight: "600" }}>VISIÓN</h5>
              <p>
                Ser una asociación reconocida por su impacto humano y social,
                promoviendo la calidad de vida, desarrollo y educación de los
                niños que apoyamos.
              </p>
            </div>
            <div className="col s12 m4">
              <img
                src="/assets/images/valores.png"
                alt="Valores"
                style={{ width: "60px", marginBottom: "1rem" }}
              />
              <h5 style={{ color: "#a2b0d3", fontWeight: "600" }}>VALORES</h5>
              <ul style={{ listStyleType: "none", padding: 0, color: "#444" }}>
                <li>Alegría</li>
                <li>Autocuidado</li>
                <li>Compartir</li>
                <li>Dedicación</li>
                <li>Empatía</li>
                <li>Ética</li>
                <li>Gratitud</li>
              </ul>
            </div>
          </div>

          {/* Íconos */}


          {/* Frase inspiradora con fondo */}
          <div
            style={{
              marginTop: "2.5rem",
              height: "220px",
              backgroundImage: "url('assets/images/actividades/foto1.jpg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
              borderRadius: "16px",
              overflow: "hidden",
            }}
          >
            {/* Capa oscura semitransparente */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundColor: "rgba(255, 64, 128, 0.75)",
                zIndex: 1,
              }}
            ></div>

            {/* Texto encima */}
            <div
              style={{
                zIndex: 2,
                position: "relative",
                color: "white",
                textAlign: "center",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 1rem",
              }}
            >
              <h5
                style={{
                  fontWeight: 600,
                  fontSize: "1.6rem",
                  lineHeight: "1.6",
                  color: "white",
                }}
              >
                Siempre habrá esperanza...
                <br /> cuando se extiende una mano amiga.
              </h5>
            </div>
          </div> 
          
          {/* Botón Regresar */}
       {/* Botón regresar */}
             <div className="center-align" style={{ marginBottom: "1.5rem" }}>
               <BotonRegresar onClick={onBack} />
             </div>
        </div>
          {/* Botón regresar */}
                
      </div>
    </div>
  );
}
